import EmbedBlock from './EmbedBlock';
export default EmbedBlock;
